export default "__VITE_ASSET__aAiVKmLq__"